import { marked } from "marked";
import { isJust, just, nothing, type Maybe, toMaybe } from "../lib/maybe";
import {
  isProjectAssetReference,
  normalizeAssetSrc,
} from "../lib/projectAssets";

marked.setOptions({
  gfm: true,
  breaks: false,
});

export function renderMarkdown(source: string): string {
  const html = marked.parse(source, { async: false });
  return typeof html === "string" ? html : "";
}

export function assetRelativeFromSrc(src: string): Maybe<string> {
  const normalized = normalizeAssetSrc(src);
  if (
    normalized.startsWith("http://") ||
    normalized.startsWith("https://") ||
    normalized.startsWith("data:") ||
    normalized.startsWith("file:")
  ) {
    return nothing;
  }

  let relative = normalized;
  if (
    isProjectAssetReference(normalized) === false &&
    normalized.includes("/") === false
  ) {
    relative = `Assets/${normalized}`;
  }
  if (isProjectAssetReference(relative) === false) return nothing;
  return just(relative);
}

export type DecodedDataUrl = {
  mediaType: string;
  bytes: Uint8Array;
};

export function decodeDataUrl(dataUrl: string): Maybe<DecodedDataUrl> {
  const match = dataUrl.match(
    /^data:([^;,]+)?(?:;charset=[^;,]+)?;base64,(.+)$/i,
  );
  if (match === null) return nothing;
  const rawType = toMaybe(match[1]);
  const mediaType =
    isJust(rawType) && rawType.value.trim() !== ""
      ? rawType.value.trim()
      : "application/octet-stream";
  const binary = atob(match[2] ?? "");
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return just({ mediaType, bytes });
}
